import { useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { LORE_TABS } from "@/data/site";
import { Reveal, SectionLabel } from "./Reveal";

const Desk = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  return (
    <div ref={ref} className="clip-frame relative h-[340px] overflow-hidden border border-amber-400/30 sm:h-[440px]">
      <motion.img style={{ y, scale: 1.3 }} src="/img/overlord.jpg" alt="Gold coin stacks on the CEO desk"
        className="absolute inset-0 h-full w-full object-cover object-[50%_85%]" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#07090e] via-[#07090e]/30 to-transparent" />
      <div className="absolute left-5 top-5 rotate-[-8deg] border-2 border-red-500/80 px-3 py-1 font-mono text-sm font-bold uppercase tracking-[0.3em] text-red-400">
        Confidential
      </div>
      <p className="absolute bottom-6 left-6 right-6 font-display text-2xl italic leading-snug text-slate-50 sm:text-3xl">
        “I don't attend meetings. <span className="text-gold">Meetings attend me.</span>”
      </p>
    </div>
  );
};

export const Lore = () => {
  const [active, setActive] = useState(LORE_TABS[0].id);
  const tab = LORE_TABS.find((t) => t.id === active);
  return (
    <section id="lore" className="relative py-24 sm:py-36" data-testid="lore-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal><SectionLabel index="01">Executive dossier</SectionLabel></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 max-w-4xl font-display text-4xl font-bold uppercase leading-[0.95] sm:text-6xl">
            One boss. One empire. <span className="text-gold">No employees safe.</span>
          </h2>
        </Reveal>
        <div className="mt-16 grid gap-12 lg:grid-cols-[1fr_1.1fr] lg:gap-16">
          <Reveal><Desk /></Reveal>
          <Reveal delay={0.15}>
            <div className="flex flex-wrap gap-2" role="tablist">
              {LORE_TABS.map((t) => (
                <button key={t.id} onClick={() => setActive(t.id)} data-testid={`lore-tab-${t.id}`}
                  className={`clip-chip px-4 py-2 font-mono text-xs uppercase tracking-[0.2em] transition-colors ${active === t.id ? "bg-amber-400 text-[#07090e]" : "border border-teal-400/25 text-slate-300 hover:text-amber-300"}`}>
                  {t.label}
                </button>
              ))}
            </div>
            <motion.div key={tab.id} initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
              className="mt-10 border-l-2 border-amber-400/60 pl-6" data-testid="lore-tab-content">
              <h3 className="font-display text-2xl font-bold text-slate-50 sm:text-3xl">{tab.title}</h3>
              <p className="mt-5 text-base leading-relaxed text-slate-300 sm:text-lg">{tab.body}</p>
            </motion.div>
            <div className="mt-12 grid grid-cols-3 border-t border-teal-400/15 pt-8">
              {[["∞", "Meetings / day"], ["0", "Employees safe"], ["1", "Boss"]].map(([v, l]) => (
                <div key={l}>
                  <p className="font-display text-3xl font-black text-gold sm:text-4xl">{v}</p>
                  <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">{l}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
